export default __webpack_public_path__ + "static/media/page-title-services-en.d74fbeb6.svg";